<div style = "padding-bottom: 20px;">
    
<input type="text" maxlength=250 [(ngModel)]="answer" (keyup)="answerQuestion(nextQuestion,answer)" (keydown.enter)="answerQuestion(nextQuestion,answer)" (focusout)="answerQuestion(nextQuestion,answer)" [placeholder]="placeholder" tabindex="0">
<div *ngIf="answer.length == 0" style="text-align: left;">
    <div class="invalid" >
        This field is required if not known please type n/k
    </div> 
</div> 
</div>
